export enum ProductType {
    RemoteSigning = "RemoteSigning",
    Hybrid = "Hybrid",
    IPEN = "IPEN",
    eSign = "eSign",
    KnownSignerRON = "KnownSignerRON"
}
